import { FC } from "react";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { FaRegCopy } from "react-icons/fa";

import { useAppDispatch } from "@/redux/store";
import { generateAlert } from "@/redux/actions";

interface CopyPromptProps {
  prompt: string;
}

const CopyPrompt: FC<CopyPromptProps> = ({ prompt }) => {
  const dispatch = useAppDispatch();

  const handleCopyPrompt = () => {
    navigator.clipboard.writeText(prompt);
    dispatch(
      generateAlert({ text: "Prompt copied to clipboard", type: "success" })
    );
  };

  if (!prompt) return null;

  return (
    <Tooltip title="Copy Prompt" arrow placement="top">
      <IconButton
        color="primary"
        onClick={handleCopyPrompt}
        aria-label="copy prompt"
      >
        <FaRegCopy style={{ fontSize: "1.25rem" }} />
      </IconButton>
    </Tooltip>
  );
};

export default CopyPrompt;
